var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoFuncaoArredondarMenos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "ico-funcao-arredondar-menos",
    transform: "translate(-334 -931)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2198",
    "data-name": "Grupo 2198"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_445",
    "data-name": "Ret\\xE2ngulo 445",
    width: 50,
    height: 50,
    transform: "translate(334 931)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2197",
    "data-name": "Grupo 2197",
    transform: "translate(59.285 681.852)",
    style: {
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1206",
    "data-name": "Caminho 1206",
    d: "M283.549,268.3h6.305l-5.09,17.473h-4.709Z",
    transform: "translate(0 5.272)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1207",
    "data-name": "Caminho 1207",
    d: "M291.205,258.149h23.017v5.318H291.205Z",
    transform: "translate(5.79)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoFuncaoArredondarMenos);
export default __webpack_public_path__ + "static/media/ico-funcao-arredondar-menos.46021dff588bbd1d0ac1860e26b3df4d.svg";
export { ForwardRef as ReactComponent };